import { app } from '../../../bootstrap/core';
import { splitViewComponent } from './splitView.component';

app.component('splitView', splitViewComponent);
